import { createFileRoute } from '@tanstack/react-router';
import { AuctionHousesPage } from '@/components/marketing/pages/AuctionHousesPage';

export const Route = createFileRoute('/_marketing/for-auction-houses')({
  component: AuctionHousesPage,
});
